export const routes = {
  landing: "/",
  login: "/login",
  referFriend: "/refer/:id",
  dashboard: "/dashboard",
  ticket: "/ticket",
  profile: "/profile",
  raffle: "/raffle",
  raffleDetail: "/raffle/:id",
  raffleResult: "/raffle-result",
  raffleResultDetail: "/raffle-result/:id",
  ticketGenerator: "/ticket-generator",
  favoriteRaffle: "/favorite-raffle",
  playedRaffles: "/played-raffles",
  exam: "/exam",
  icons: "/icons",
  widget: "/widget",
  prizeRedemption: "/prize-redemption",
  verify: "/verify-email",
  gift: "/gift",
  preview: "/preview",
  dashboardPreview: "/dashboard-preview",
  contact: "/contact",
  spinWheel: "/spin-wheel",
};
